import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common';
import { LockClosedIcon } from '@heroicons/react/20/solid';
import { dataTestId } from '@services/data-test-id';


/**
 * @description Renders the login button in the navbar
 */
export const LoginButton = ({ toEmployerLogin = false, className = '' }: { toEmployerLogin?: boolean, className?: string, locale?: Locale }) => {
  // translate
  const { t } = useTranslation('common');

  const href = toEmployerLogin ? '/login/recruiter' : '/login';

  return (
    <LinkStyled
      href={href}
      rounding="full"
      styling="outline"
      size="xs"
      color="ink"
      className={`min-w-fit !px-6 !py-3 md:ml-6 md:!px-4.5 md:!py-2 md:!text-tiny lg:order-last ${className}`}
      {...dataTestId('navbar.loginButton')}
    >
      <LockClosedIcon className="-mt-px mr-1.5 size-3.5" />
      {t('menu.sign_in-register')}
    </LinkStyled>
  );
};
